// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
(function() {

$(document).on("turbo:load", function() {

  if ($("#wage_user_id").is(':visible')) {
    $("#wage_user_id").select2({placeholder: "担当弁護士"});
  }

  if ($("#wage_matter_id").is(':visible')) {
    $("#wage_matter_id").select2({placeholder: "依頼人：事件名", allowClear: true});
    // 事件選択時に関連弁護士プルダウンを更新
    new Select2Cascade($('#wage_matter_id'), $('#wage_payer_id'), '/matters/:parentId:/matter_users', {});
  }

  $('#wage_payer_id').select2({allowClear: true});

  $(".form_datetime").on('dp.change', function(e) {
    if ($("#wage_start").val() && $("#wage_end").val()) {
      const start = moment($("#wage_start").val().replace(/\//g, '-'));
      const end = moment($("#wage_end").val().replace(/\//g, '-'));
      const duration_minutes = end.diff(start, 'minutes');
      $("#wage_duration").val(Math.round((duration_minutes / 60) * 100) / 100);
      $("#wage_duration_minutes").val(duration_minutes);
      calculate_wage();
    }
  });
  // 時間給自動入力
  $("#wage_duration").on('change', function(e) {
    const start = $("#wage_start").val();
    const end = $("#wage_end").val();
    const duration = $("#wage_duration").val();

    if (start && !end && duration) {
      const startMoment = moment(start.replace(/\//g, '-'));
      const endMoment = startMoment.add(duration, 'hours');
      $("#wage_end").val(endMoment.format('YYYY/MM/DD HH:mm'));
      $("#wage_duration_minutes").val(parseFloat(duration) * 60);
    } else if (duration) {
      $("#wage_duration_minutes").val(parseFloat(duration) * 60);
    }

    calculate_wage();
  });
  $("#wage_rate").on('change', e => calculate_wage());

  $("#wage_raw_amount").on('keyup focusout', calc_tax);
  $('input[name=wage\\[consumption_tax\\]]:radio').on('change', calc_tax);
  $('input[name=wage\\[tax_withhold\\]]:radio').on('change', calc_tax);
  calc_tax();

  // タイマーからの遷移等でdurationに初期値がある場合、金額を自動計算
  if ($("#wage_duration").val()) {
    calculate_wage();
  }
});

const calculate_wage = function() {
  const rate = parseFloat($("#wage_rate").text());
  const hours = billable_hours();
  if ($.isNumeric(rate) && $.isNumeric(hours)) {
    $("#wage_raw_amount").val(Math.round(hours * rate));
  }
  calc_tax();
};

const billable_hours = function() {
  const duration_minutes = parseFloat($("#wage_duration_minutes").val());
  if ($.isNumeric(duration_minutes)) {
    return duration_minutes / 60;
  }

  if ($("#wage_start").val() && $("#wage_end").val()) {
    const start = moment($("#wage_start").val().replace(/\//g, '-'));
    const end = moment($("#wage_end").val().replace(/\//g, '-'));
    return end.diff(start, 'minutes') / 60;
  }

  const duration = parseFloat($("#wage_duration").val());
  if ($.isNumeric(duration)) { return duration; }
  return null;
};

const CONSUMPTION_TAX_RATE = 0.1;
const calc_tax = function() {
  const amt = Math.round($("#wage_raw_amount").val());
  if ($.isNumeric(amt)) {
    let consumption_tax, net_amount, raw_amount;
    if ($('input[name=wage\\[consumption_tax\\]]:checked').val() === 'inclusive') {
      consumption_tax = Math.round((amt / (1 + CONSUMPTION_TAX_RATE)) * CONSUMPTION_TAX_RATE);
      raw_amount = amt - consumption_tax;
      net_amount = amt;
    } else {
      consumption_tax = Math.round(CONSUMPTION_TAX_RATE * amt);
      raw_amount = amt;
      net_amount = amt + consumption_tax;
    }

    const withholding_amount = calc_with_holding_tax(raw_amount);
    const amount = net_amount - withholding_amount;

    // Set table fields
    $('#wage_tbl_raw_amount').first().text(raw_amount.toLocaleString());
    $('#wage_tbl_consumption_tax_amount').first().text(consumption_tax.toLocaleString());
    $('#wage_tbl_net_amount').first().text(net_amount.toLocaleString());
    $('#wage_tbl_withholding_amount').first().text(withholding_amount.toLocaleString());
    $('#wage_tbl_amount').first().text(amount.toLocaleString());

    // Set hidden inputs
    $("#wage_consumption_tax_amount").val(consumption_tax);
    $("#wage_net_amount").val(Math.round(net_amount));
    $("#wage_withholding_amount").val(withholding_amount);
    $("#wage_amount").val(Math.round(amount));
  }
};

const calc_with_holding_tax = function(amt) {
  if ($('input[name=wage\\[tax_withhold\\]]:checked').val() === 'withhold_no') {
    return 0;
  }
  if (amt <= 1000000) {
    return Math.floor(amt * 0.1021);
  } else {
    return Math.floor(((amt - 1000000) * 0.2042) + 102100);
  }
};

})();
